<template>
  <div class="row">
    <div class="col-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3 text-center">
      <section>
        <h1>{{ $t("login") }}</h1>
      </section>
      <section class="mb-5" v-if="error">
        <div class="alert alert-danger">
          {{ error }}
        </div>
      </section>
      <section>
        <form @submit.prevent="login" id="form">
          <div class="form-floating mb-4">
            <input
              id="email"
              class="form-control"
              :placeholder="$t('emailAddress')"
              type="email"
              v-model="email"
              required
            />
            <label for="email"> {{ $t("emailAddress") }} </label>
            <div class="invalid-feedback text-start">
              {{ $t("errorInvalidEmail") }}
            </div>
          </div>

          <div class="form-floating mb-2">
            <input
              id="password"
              class="form-control"
              :placeholder="$t('password')"
              :type="passwordType"
              v-model="password"
              minlength="6"
              required
            />
            <label for="password"> {{ $t("password") }} </label>
            <div class="invalid-feedback text-start">
              {{ $t("errorInvalidPassword") }}
            </div>
          </div>

          <button
            class="btn btn-link btn-block w-100 mb-4 shadow-none"
            type="button"
            @click.prevent="togglePassword"
          >
            <span v-if="showPassword">{{ $t("hidePassword") }}</span>
            <span v-else>{{ $t("showPassword") }}</span>
          </button>

          <div class="form-check mb-4">
            <input
              id="keepLoggedIn"
              class="form-check-input"
              type="checkbox"
              v-model="keepLoggedIn"
            />
            <label class="form-check-label" for="keepLoggedIn">
              {{ $t("keepLoggedIn") }}
            </label>
          </div>

          <button
            type="submit"
            class="btn btn-secondary mb-4 w-100"
            :disabled="loginButtonDisabled"
            @click.prevent="login"
          >
            <span v-if="!loading">{{ $t("login") }}</span>
            <Spinner v-else centered />
          </button>

          <router-link
            class="btn btn-link btn-block w-100 mb-4 shadow-none"
            :to="{ name: 'account.passwordReset' }"
          >
            {{ $t("passwordReset") }}
          </router-link>

          <router-link
            class="btn btn-link btn-block w-100 mb-4 shadow-none"
            :to="{ name: 'account.register' }"
          >
            {{ $t("noMemberregisterNow") }}
          </router-link>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import Spinner from "../../components/Spinner";
export default {
  name: "Login",
  components: { Spinner },
  data() {
    return {
      form: null,
      formValid: false,
      email: null,
      password: null,
      showPassword: false,
      keepLoggedIn: true,
      loading: false,
      error: null,
    };
  },
  computed: {
    passwordType() {
      return this.showPassword ? "text" : "password";
    },
    loginButtonDisabled() {
      return !this.formValid || this.loading;
    },
  },
  watch: {
    email() {
      this.formValid = this.form.checkValidity();
    },
    password() {
      this.formValid = this.form.checkValidity();
    },
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      this.error = null;
      if (this.form.checkValidity()) {
        this.form.classList.add("was-validated");
        this.loading = true;
        try {
          await this.authLogin({
            email: this.email,
            password: this.password,
            keepLoggedIn: this.keepLoggedIn,
          });
          await this.$router.push({ name: "profile" });
        } catch (error) {
          this.loading = false;
          this.error = this.globalErrorText(error);
        }
      } else {
        this.form.classList.add("was-validated");
      }
    },
  },
  mounted() {
    this.form = document.getElementById("form");
  },
};
</script>

<style scoped></style>
